export default (data = [], valuePath, labelPath) => {
  return data.map((o) => ({ label: o[labelPath], value: o[valuePath] }));
};
